<script lang="ts">
  import {formatStyleString} from 'Catalyst/utility/theme';
  import {getCssProperty} from 'Utility/whiteLabeling';

  export let mappings: Record<string, string> = {};

  // if override is set use the override and not the default catalyst colors
  // if override is not set use the default catalyst colors
  const mapVariables = (
    catalystOverrides: object,
    override: string,
    catalystKey: string
  ) => {
    if (override.startsWith('--')) {
      const cssColor = getCssProperty(override);

      if (cssColor) {
        catalystOverrides[catalystKey] = cssColor;
      }
    } else {
      catalystOverrides[catalystKey] = override;
    }
  };

  const buildMapping = () => {
    const catalystOverrides = {};

    mapVariables(
      catalystOverrides,
      '--dm-primary-color',
      '--button-compound-variants-style-filled-and-semantic-brand-base-bg-color'
    );

    mapVariables(
      catalystOverrides,
      '--dm-primary-color',
      '--button-compound-variants-style-filled-and-semantic-brand-base-bg-color'
    );

    mapVariables(
      catalystOverrides,
      '--dm-primary-color',
      '--button-compound-variants-style-filled-and-semantic-brand-and-state-hover-base-bg-color'
    );

    mapVariables(
      catalystOverrides,
      '--dm-primary-color',
      '--button-compound-variants-style-filled-and-semantic-brand-and-state-focus-base-bg-color'
    );

    mapVariables(
      catalystOverrides,
      '--dm-primary-color',
      '--button-compound-variants-style-filled-and-semantic-brand-and-state-active-base-bg-color'
    );

    mapVariables(
      catalystOverrides,
      '--dm-cta-background-color-disabled',
      '--button-compound-variants-style-filled-and-state-disabled-base-bg-color'
    );

    mapVariables(
      catalystOverrides,
      '--dm-rounded-corners',
      '--button-slots-base-border-radius'
    );

    mapVariables(
      catalystOverrides,
      '--dm-text-primary-color',
      '--button-compound-variants-style-filled-and-semantic-brand-label-color'
    );

    for (const key in mappings) {
      const value = mappings[key];

      mapVariables(catalystOverrides, value, key);
    }

    return formatStyleString(catalystOverrides, '');
  };

  $: styleString = buildMapping();
</script>

<div style={styleString} data-testid="catalyst-style-override">
  <slot />
</div>
